import { Injectable } from "@angular/core";
import {  Observable, throwError } from "rxjs";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  catchError,
} from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthModel } from "../auth.model";
import { MessagesService } from "src/app/services/service.index";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {



  private readonly authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  private auth: AuthModel;
constructor(  
  private router: Router,
  	private messagesService: MessagesService,){


}
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  this.auth = JSON.parse(localStorage.getItem(this.authLocalStorageToken));

  if (this.auth && this.isTokenExpired(this.auth.accessToken)) {
    console.warn('Token expirado, limpiando sesión');
    this.clearSession();
    this.router.navigateByUrl('/login');
    return throwError(() => new Error('Token expirado'));
  }

  // Agregar cabeceras
  if (!req.headers.has("Content-Type")) {
    req = req.clone({
      headers: req.headers.set("Content-Type", "application/json"),
    });
  }

  req = req.clone({
    headers: req.headers
      .set("OPHJsonNamingStrategy", "camelcase")
      .set("Access-Control-Allow-Origin", "*"),
  });

  req = this.addAuthenticationToken(req);

  return next.handle(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error && error.status === 401) {
        this.messagesService.error("Acceso no autorizado");
        this.clearSession();
        this.router.navigateByUrl('/login');
      }
      return throwError(() => error);
    })
  );
}

private isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // convertir a milisegundos
    return Date.now() > exp;
  } catch (e) {
    console.error('Error verificando token:', e);
    return true; // si no se puede leer, asumimos que está vencido
  }
}

private clearSession() {
  localStorage.removeItem(this.authLocalStorageToken);
  localStorage.removeItem('licensemessageerror');
  localStorage.removeItem('login_option');
  localStorage.removeItem('Pages');
  localStorage.removeItem('listHisotrial');
  localStorage.setItem('logout', JSON.stringify('S'));
 
}

private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {

  if (!this.auth) {
    return request;
  }
  if (this.auth) {
    return (request = request.clone({
      setHeaders: {
        Authorization: this.auth.accessToken,
      },
    }));
  }
  return request;
}


}
